const ROUTES = {
  // HOME: '/',
  LOGIN: "/login",
  NEWUSERREGISTRATION: "/newuserregistration",
  FORGOTPASSWORD: "/forgotpassword",
  UNAUTHORIZED: "/unauthorized",
  PROFILE: "/profile",
  DASHBOARD: "/dashboard",
  SIMPLEVIEW: "simple-view",
  DETAILVIEW: "detail-view",
  SITEOVERVIEW: "site-overview",
  CONTROLPANEL: "control-panel",
  DIAGNOTIC: "diagnostic",
  REPORTS: "reports",
  USERMGMT: "user-management",
  DIVISIONDETAILS: "division-details",
};

export default ROUTES;
